import * as React from 'react';
import { connect } from 'react-redux';
import type { RootState } from 'typesafe-actions';

type MappedState = {
  products?: string[];
};

export function withStoreLogic<TOwnProps>(
  WrappedComponent: React.ComponentType<TOwnProps & MappedState>,
  productsSelector: (state: RootState) => string[],
) {
  return connect<MappedState, Record<string, never>, TOwnProps, RootState>(
    getMapStateToPropsFunc(productsSelector),
  )(WrappedComponent as React.ComponentType<MappedState>);
}

export const getMapStateToPropsFunc =
  (productsSelector: (state: RootState) => string[]) => (state: RootState) => ({
    products: productsSelector(state),
  });
